import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgSDM20LHT extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 0,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg width={size} height={size} viewBox="0 0 300 290.31">
                <g fill={color}>
                    <path d="M244.23,128.56l-7.14,4.9a15.87,15.87,0,0,1,9.44,2.88,9.78,9.78,0,0,1-2.39-7.34C244.16,128.85,244.2,128.7,244.23,128.56Z" />
                    <path d="M252.24,123a15.24,15.24,0,0,1,5.58,1.16,8.55,8.55,0,0,1-.72-4.49Z" />
                    <path d="M206.79,145.13l64.37-44.25c1.94-5.35,4.4-12,6.33-16.93,1.84-4.69,2-8.09,1.56-10.49l-94.76,58Z" />
                    <path d="M265.92,113.64a16.78,16.78,0,0,1,10.57,4.92c2.68,2.7,4,5.88,3.55,8.74a6.58,6.58,0,0,1-3.5,4.91,9.61,9.61,0,0,1-4.58,1.06,15,15,0,0,1-5.62-1.2,8.46,8.46,0,0,1,.73,4.65,6.59,6.59,0,0,1-3.49,4.91,9.65,9.65,0,0,1-4.59,1.06,16.05,16.05,0,0,1-8.7-2.82,9.77,9.77,0,0,1,2.32,7.25,6.61,6.61,0,0,1-3.5,4.91,9.63,9.63,0,0,1-4.58,1.06,15.91,15.91,0,0,1-8.11-2.49,9.47,9.47,0,0,1,1.79,6.61,6.57,6.57,0,0,1-3.5,4.9,9.64,9.64,0,0,1-4.58,1.07,15.05,15.05,0,0,1-5.58-1.17,24.69,24.69,0,0,1-.23,3.73c-.72,5.41-2.87,12.81-5.06,19.42l77.79-61.56a3.47,3.47,0,0,0-.84-.5l-24.84-13.2Z" />
                    <path d="M229.91,138.4l-7.51,5.16a15.57,15.57,0,0,1,9,2.41,9.47,9.47,0,0,1-1.77-6.57A6.35,6.35,0,0,1,229.91,138.4Z" />
                    <path d="M213.63,199.23a3.86,3.86,0,0,1-4.59.07,3.78,3.78,0,0,1-1.27-4.39c.08-.21,7.72-20,9.07-30.18.4-3,0-4.52-.33-5.1l-22.6,16.07L162.56,290.31h.36a8.8,8.8,0,0,0,6.08-2.38l108.77-98.2a1.78,1.78,0,0,0,.47-.65c.65-1.52,16-37.39,20.37-50.67a24.2,24.2,0,0,0,1.39-7.52Z" />
                    <path d="M186.27,175.05.53,53.12a8.69,8.69,0,0,0-.39,4.55l0,101a1,1,0,0,0,0,.17C.35,161.28,4,164.37,6,166,7.35,167,136.57,271,148.35,282.68a33.33,33.33,0,0,0,7,5.48ZM8.36,163c-.61-.47-1.2-1-1.76-1.48l1.82,1.52Z" />
                    <path d="M215.27,149.49a6.43,6.43,0,0,1,.31-1.24l-1.71,1.18,1.34.82A6.32,6.32,0,0,1,215.27,149.49Z" />
                    <path d="M173.26,131.45a3.75,3.75,0,0,1,1.82-3.22l99.24-60.72L145.63.21A1.93,1.93,0,0,0,144.14.1C142.87.55,17.06,45,8.58,46.86A15.43,15.43,0,0,0,6,47.67L190.54,168.83l18.77-13.34-34.23-20.81A3.82,3.82,0,0,1,173.26,131.45ZM101.58,63.54,89.41,56.08s1.64-.93,1.64-2.34c0-2.16-5.41-6.46-13.56-6.46S66,51.58,66,53.74s3.32,5.41,11.47,5.41A28.53,28.53,0,0,0,80.58,59l1.07-.11,12.25,8-5.4,3-8.38-5.79c-.87.06-1.75.1-2.63.1-11.19,0-18.59-3.9-18.59-10.45s7.4-11.49,18.59-11.49,19.63,4.94,19.63,11.49a6.4,6.4,0,0,1-.05.88l9.71,5.79Z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgSDM20LHT);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgSDM20LHT.js